import { useMediaQuery } from 'usehooks-ts'
import Modal from '../Modal/Modal'
import { MobileModalProps } from './MobileModal.types'
import { deviceSizes } from '../../theme/deviceSizes'

function MobileModal({
  id,
  heading,
  children,
  isModalVisible,
  handleModalClose: onModalClose,
  disablePlaceholder,
  allowScroll,
  placeholder,
  forceModal,
}: MobileModalProps) {
  const isLargerThanMobile = useMediaQuery(`(min-width: ${deviceSizes.medium})`)
  const shouldRenderModal = forceModal || !isLargerThanMobile

  if (!shouldRenderModal) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  if (!isModalVisible) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{placeholder || children}</>
  }

  return (
    <>
      {!disablePlaceholder && (placeholder || children)}
      <Modal
        id={id}
        title={heading}
        preventScroll={!allowScroll}
        isOpen={isModalVisible}
        onClose={onModalClose}
      >
        {children}
      </Modal>
    </>
  )
}

export default MobileModal
